import DefaultView from "nette-front-module/js/views/front.default";
import merge from "lodash/merge";
import LiveForm from "nette-base-module/js/nette/LiveForm";

export default merge(
  {
    mounted() {
      if (this.$el.id === "snippet--page") {
        LiveForm.Nette.validators.AppCrmModuleModelValidators_isPhoneNumberControl = () => {
          return true;
        };
        import("libphonenumber-js").then(({ parsePhoneNumber }) => {
          LiveForm.Nette.validators.AppCrmModuleModelValidators_isPhoneNumberControl = (
            elem,
            arg,
            val
          ) => {
            if (!val) return false;
            if (new String(val).length <= 4) return false;

            try {
              const phoneNumber = parsePhoneNumber(val, "CZ");
              return phoneNumber.isValid();
            } catch (err) {
              return false;
            }
          };
        });
      }
    },
    methods: {
    }
  },
  DefaultView
);
